export type RefererHeader = {
  'x-referer': string
}

export const getRefererHeader = (): RefererHeader => {
  return {
    'x-referer': window.location.href,
  }
}
